import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "moment";
import CatalogueTopNav from "../new-service/CatalogueTopNav";
import { formService } from "../../_services/form.service";

import "./Forms.css";
import "../new-service/service.css";

/**
 * FormSubmissionView - View a completed form submission's responses
 */
const FormSubmissionView = (props) => {
  const [submission, setSubmission] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const submissionId = props.match?.params?.submissionId;

  useEffect(() => {
    // Try location state first (passed from ClientDetail), otherwise fetch from API
    if (props.location?.state?.submission) {
      setSubmission(props.location.state.submission);
      setLoading(false);
    } else if (submissionId) {
      loadSubmission(submissionId);
    } else {
      setError("No submission ID provided");
      setLoading(false);
    }
  }, [submissionId]);

  const loadSubmission = (id) => {
    setLoading(true);
    formService.viewSubmission({ submissionId: id })
      .then((response) => {
        const data = response?.data?.responseData;
        if (data?.result) {
          setSubmission(data.result);
        } else {
          setError("Submission not found");
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error loading submission:", err);
        setError("Failed to load submission");
        setLoading(false);
      });
  };

  const formatQuestionType = (type) => {
    const labels = {
      client_field: 'Client Details',
      short_answer: 'Short Answer',
      long_answer: 'Long Answer',
      multiple_choice: 'Multiple Choice',
      checkbox: 'Checkbox',
      dropdown: 'Dropdown',
      yes_no: 'Yes / No',
      signature: 'Signature',
    };
    return labels[type] || type;
  };

  const goBack = () => {
    if (props.history.length > 1) {
      props.history.goBack();
    } else {
      props.history.push("/forms");
    }
  };

  const renderAnswer = (response) => {
    if (response.answer === null || response.answer === undefined) {
      return <span className="submission-no-answer">No answer</span>;
    }
    if (Array.isArray(response.answer)) {
      return response.answer.join(", ");
    }
    if (typeof response.answer === "boolean") {
      return response.answer ? "Yes" : "No";
    }
    return String(response.answer);
  };

  return (
    <div className="h_n catalogue-no-header">
      <div className="body_container cm_bg_white">

        <div className="catalogue-page-wrapper">
          <CatalogueTopNav />

          <div className="catalogue-content-container">
            <div className="catalogue-content-wrapper">
              {/* Back button and header */}
              <div style={{ marginBottom: "24px" }}>
                <button
                  onClick={goBack}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: "#666",
                    padding: "0",
                    marginBottom: "16px",
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M19 12H5M12 19l-7-7 7-7" />
                  </svg>
                  Back
                </button>

                {loading ? (
                  <div style={{ textAlign: "center", padding: "60px 20px", color: "#999" }}>
                    <p>Loading submission...</p>
                  </div>
                ) : error ? (
                  <div style={{ textAlign: "center", padding: "60px 20px", color: "#999" }}>
                    <p>{error}</p>
                  </div>
                ) : submission ? (
                  <div>
                    {/* Submission Header */}
                    <div style={{
                      background: "#fff",
                      borderRadius: "12px",
                      border: "1px solid #e8e8e8",
                      padding: "24px",
                      marginBottom: "20px",
                    }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                        <div>
                          <h2 style={{ fontSize: "20px", fontWeight: "600", margin: "0 0 8px 0", color: "#1a1a1a" }}>
                            {submission.formName || submission.formTemplate?.name || "Untitled Form"}
                          </h2>
                          <div style={{ display: "flex", gap: "16px", fontSize: "13px", color: "#888" }}>
                            {submission.completedAt && (
                              <span>Completed {moment(submission.completedAt).format("DD MMM YYYY [at] HH:mm")}</span>
                            )}
                            {submission.sentAt && (
                              <span>Sent {moment(submission.sentAt).format("DD MMM YYYY")}</span>
                            )}
                          </div>
                        </div>
                        <span style={{
                          display: "inline-block",
                          padding: "4px 12px",
                          borderRadius: "20px",
                          fontSize: "12px",
                          fontWeight: "500",
                          background: submission.status === "completed" ? "#e6f9f0" : "#fff3e0",
                          color: submission.status === "completed" ? "#2e7d5b" : "#e65100",
                        }}>
                          {submission.status === "completed" ? "Completed" : "Pending"}
                        </span>
                      </div>
                    </div>

                    {/* Responses */}
                    {submission.responses && submission.responses.length > 0 ? (
                      <div style={{
                        background: "#fff",
                        borderRadius: "12px",
                        border: "1px solid #e8e8e8",
                        overflow: "hidden",
                      }}>
                        <div style={{
                          padding: "16px 24px",
                          borderBottom: "1px solid #e8e8e8",
                          background: "#fafafa",
                        }}>
                          <h3 style={{ fontSize: "15px", fontWeight: "600", margin: 0, color: "#1a1a1a" }}>
                            Responses ({submission.responses.length})
                          </h3>
                        </div>
                        <div>
                          {submission.responses.map((response, index) => (
                            <div
                              key={index}
                              style={{
                                padding: "16px 24px",
                                borderBottom: index < submission.responses.length - 1 ? "1px solid #f0f0f0" : "none",
                              }}
                            >
                              <div style={{ fontSize: "13px", color: "#888", marginBottom: "4px" }}>
                                {response.questionType && (
                                  <span>{formatQuestionType(response.questionType)}</span>
                                )}
                              </div>
                              <div style={{ fontSize: "14px", fontWeight: "500", color: "#1a1a1a", marginBottom: "6px" }}>
                                {response.questionText || "Question"}
                              </div>
                              <div style={{ fontSize: "14px", color: "#444" }}>
                                {renderAnswer(response)}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <div style={{
                        background: "#fff",
                        borderRadius: "12px",
                        border: "1px solid #e8e8e8",
                        padding: "40px 24px",
                        textAlign: "center",
                        color: "#999",
                      }}>
                        <p>No responses recorded yet</p>
                      </div>
                    )}

                    {/* Signature */}
                    {submission.signature && (
                      <div style={{
                        background: "#fff",
                        borderRadius: "12px",
                        border: "1px solid #e8e8e8",
                        padding: "24px",
                        marginTop: "20px",
                      }}>
                        <h3 style={{ fontSize: "15px", fontWeight: "600", margin: "0 0 12px 0", color: "#1a1a1a" }}>
                          Signature
                        </h3>
                        <div style={{
                          background: "#fafafa",
                          borderRadius: "8px",
                          padding: "16px",
                          textAlign: "center",
                        }}>
                          <img
                            src={submission.signature}
                            alt="Client signature"
                            style={{ maxWidth: "100%", maxHeight: "200px" }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    ...state,
  };
}

export default connect(mapStateToProps)(FormSubmissionView);
